import { parseISO } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

export const getTimeZoneAgnosticDate = (isoDateString: string) => {
  const date = parseISO(isoDateString)

  const utcDate = utcToZonedTime(date, 'UTC')

  return utcDate
}
